module.exports = __webpack_public_path__ + "img/20.d78a8766.jpg";